import { AuthenticatedRoute, AuthViewProps, GoogleCallback, UnauthenticatedRoute } from "@homebound/auth-components";
import { Redirect, Switch } from "react-router-dom";
import { LotsPage } from "src/routes/lots/LotsPage";
import { SignIn } from "./routes/auth/SignIn";
import { DrawOverviewPage } from "./routes/funds/draws/DrawOverviewPage";
import { FundsPage } from "./routes/funds/FundsPage";
import { InvoiceOverviewPage } from "./routes/funds/invoices/InvoiceOverviewPage";
import { FundOverviewPage } from "./routes/funds/overview/FundOverviewPage";
import { PaymentOverviewPage } from "./routes/funds/payments/PaymentOverviewPage";
import { LotOverviewPage } from "./routes/lots/overview/LotOverviewPage";
import { LotPartitionDocumentsPage } from "./routes/lots/partitionDocuments/LotPartitionDocumentsPage";
import {
  checkoutControlsPath,
  drawPath,
  drawRequestPath,
  fundAllocationsPath,
  fundLoanManagementPath,
  fundPath,
  fundsPath,
  invoicePath,
  lotAcqPurchaseAgreementPath,
  lotAcqSettlementStatementPath,
  lotPartitionDocumentsPath,
  lotPath,
  lotsPath,
  metrosPath,
  paymentPath,
  propertySaleSettlementStatementPath,
  underwritingDefaultsPath,
} from "./routes/routesDef";
import { MetrosPage } from "./routes/metros/MetrosPage";
import { DrawRequestOverviewPage } from "./routes/funds/drawRequests/DrawRequestOverviewPage";
import { FundLoanManagementPage } from "./routes/funds/loanManagement/FundLoanManagementPage";
import { LotAcqSettlementStatementEditor } from "./routes/lots/acqSettlementStatement/LotAcqSettlementStatementEditor";
import { LotAcqPurchaseAgreementEditor } from "./routes/lots/acqPurchaseAgreement/LotAcqPurchaseAgreementEditor";
import { FundAllocationsPage } from "./routes/fundAllocations/FundAllocationsPage";
import { UnderwritingOverviewPage } from "./routes/underwriting/UnderwritingOverviewPage";
import { PropertySaleSettlementStatementEditor } from "./routes/lots/propertySaleSettlementStatement/PropertySaleSettlementStatementEditor";
import { CheckoutControlsPage } from "./routes/checkoutControls/CheckoutControlsPage";

export type ProjectRouteProps = { projectId: string };

export function Routes({ authProps }: { authProps: AuthViewProps }) {
  return (
    <Switch>
      <Redirect exact from="/" to={lotsPath} />
      <AuthenticatedRoute path={lotsPath} component={LotsPage} authProps={authProps}></AuthenticatedRoute>
      <AuthenticatedRoute
        path={lotPartitionDocumentsPath}
        component={LotPartitionDocumentsPage}
        authProps={authProps}
      ></AuthenticatedRoute>
      <AuthenticatedRoute path={lotPath} component={LotOverviewPage} authProps={authProps}></AuthenticatedRoute>
      <AuthenticatedRoute path={fundsPath} component={FundsPage} authProps={authProps}></AuthenticatedRoute>
      <AuthenticatedRoute path={fundPath} component={FundOverviewPage} authProps={authProps}></AuthenticatedRoute>
      <AuthenticatedRoute
        path={fundLoanManagementPath}
        component={FundLoanManagementPage}
        authProps={authProps}
      ></AuthenticatedRoute>

      <AuthenticatedRoute path={drawPath} component={DrawOverviewPage} authProps={authProps}></AuthenticatedRoute>
      <AuthenticatedRoute
        path={drawRequestPath}
        component={DrawRequestOverviewPage}
        authProps={authProps}
      ></AuthenticatedRoute>
      <AuthenticatedRoute path={paymentPath} component={PaymentOverviewPage} authProps={authProps}></AuthenticatedRoute>
      <AuthenticatedRoute path={invoicePath} component={InvoiceOverviewPage} authProps={authProps}></AuthenticatedRoute>

      <AuthenticatedRoute path={metrosPath} component={MetrosPage} authProps={authProps}></AuthenticatedRoute>
      <AuthenticatedRoute
        path={lotAcqSettlementStatementPath}
        component={LotAcqSettlementStatementEditor}
        authProps={authProps}
      ></AuthenticatedRoute>
      <AuthenticatedRoute
        path={lotAcqPurchaseAgreementPath}
        component={LotAcqPurchaseAgreementEditor}
        authProps={authProps}
      ></AuthenticatedRoute>
      <AuthenticatedRoute
        path={propertySaleSettlementStatementPath}
        component={PropertySaleSettlementStatementEditor}
        authProps={authProps}
      ></AuthenticatedRoute>

      <AuthenticatedRoute
        path={fundAllocationsPath}
        component={FundAllocationsPage}
        authProps={authProps}
      ></AuthenticatedRoute>

      <AuthenticatedRoute
        path={underwritingDefaultsPath}
        component={UnderwritingOverviewPage}
        authProps={authProps}
      ></AuthenticatedRoute>

      <AuthenticatedRoute
        path={checkoutControlsPath}
        component={CheckoutControlsPage}
        authProps={authProps}
      ></AuthenticatedRoute>

      <UnauthenticatedRoute path="/signIn" exact component={SignIn} authProps={authProps} />
      <UnauthenticatedRoute path="/auth/gcallback" exact component={GoogleCallback} authProps={authProps} />
    </Switch>
  );
}
